'use client'

import dynamic from 'next/dynamic'
import { FC } from 'react'

import { Props } from '@/components/Layout/Header/Molecules/HeaderProductLinks/HeaderPorductLinksLogic'

const HeaderPorductLinksLogic = dynamic(
  () => import('@/components/Layout/Header/Molecules/HeaderProductLinks/HeaderPorductLinksLogic'),
  {
    ssr: false,
  }
)

const HeaderProductLinks: FC<Props> = ({ products, nextLink = true }) => {
  return (
    <>
      <HeaderPorductLinksLogic nextLink={nextLink} products={products} />
    </>
  )
}

export default HeaderProductLinks
